export const hiddenStyles = {
  opacity: 0,
  height: '0%',
  overflow: 'hidden',
  margin: 0,
}
